export default __webpack_public_path__ + "static/media/15.94508835.jpg";